import React from 'react';
import PropTypes from 'prop-types';
import { uncontrollable } from 'uncontrollable';
const TAB = 'tab';
const PANE = 'pane';
class TabContainer extends React.Component {
  getChildContext() {
    const {
      activeKey,
      onSelect,
      generateChildId,
      id
    } = this.props;
    const getId = generateChildId || ((key, type) => id ? `${id}-${type}-${key}` : null);
    return {
      $bs_tabContainer: {
        activeKey,
        onSelect,
        getTabId: key => getId(key, TAB),
        getPaneId: key => getId(key, PANE)
      }
    };
  }
  render() {
    const {
      children,
      ...props
    } = this.props;
    delete props.generateChildId;
    delete props.onSelect;
    delete props.activeKey;
    return /*#__PURE__*/React.cloneElement(React.Children.only(children), props);
  }
}
TabContainer.childContextTypes = {
  $bs_tabContainer: PropTypes.shape({
    activeKey: PropTypes.any,
    onSelect: PropTypes.func.isRequired,
    getTabId: PropTypes.func.isRequired,
    getPaneId: PropTypes.func.isRequired
  })
};
export default uncontrollable(TabContainer, {
  activeKey: 'onSelect'
});